export type GetSortFieldParams<S extends string> = {
	sortField?: string | null;
	sortableFields: readonly S[] | S[];
	defaultSortField: S;
};

export const getSortField = <S extends string>({
	sortField,
	sortableFields,
	defaultSortField,
}: GetSortFieldParams<S>): S =>
	sortField != null && sortableFields.includes(sortField as S)
		? (sortField as S)
		: defaultSortField;

export default getSortField;
